module.exports = __webpack_public_path__ + "static/burger-a17f309773c4386cb8cc5d67c83f1bf3.jpg";